import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SectionIntro from './SectionIntro';
import { galleryImages } from '../data/content';

const { FiX, FiZoomIn } = FiIcons;
const categories = ['All', 'Interior', 'Exterior', 'Commercial', 'Resurfacing'];

function Gallery() {
  const [category, setCategory] = useState('All');
  const [selected, setSelected] = useState(null);
  const reduceMotion = useReducedMotion();
  const filtered = category === 'All'
    ? galleryImages
    : galleryImages.filter((image) => image.category === category);

  return (
    <section className="section gallery" id="gallery">
      <div className="container">
        <SectionIntro
          eyebrow="Our Work"
          title="See the Difference for Yourself"
          description="A closer look at the craftsmanship, preparation, and detail behind every finish."
          centered
        />

        <div className="gallery-tabs" role="tablist" aria-label="Gallery categories">
          {categories.map((item) => (
            <button
              type="button"
              role="tab"
              aria-selected={category === item}
              className={category === item ? 'active' : ''}
              onClick={() => setCategory(item)}
              key={item}
            >
              {item}
            </button>
          ))}
        </div>

        <motion.div layout className="gallery-grid">
          <AnimatePresence mode="popLayout">
            {filtered.map((image, index) => (
              <motion.button
                layout
                type="button"
                className={`gallery-card gallery-card-${index + 1}`}
                key={image.src}
                onClick={() => setSelected(image)}
                initial={reduceMotion ? false : { opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
              >
                <img src={image.src} alt={image.alt} loading="lazy" />
                <span><SafeIcon icon={FiZoomIn} /> {image.category}</span>
              </motion.button>
            ))}
          </AnimatePresence>
        </motion.div>
        <p className="gallery-note">Placeholder imagery — replace with real project and before/after photos before launch.</p>
      </div>

      <AnimatePresence>
        {selected && (
          <motion.div
            className="lightbox"
            role="dialog"
            aria-modal="true"
            aria-label="Project image preview"
            initial={reduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <button type="button" aria-label="Close image preview" onClick={() => setSelected(null)}>
              <SafeIcon icon={FiX} />
            </button>
            <motion.img
              src={selected.src}
              alt={selected.alt}
              initial={reduceMotion ? false : { scale: 0.92 }}
              animate={{ scale: 1 }}
              onClick={(event) => event.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}

export default Gallery;